import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFieldComponent } from './custom-field/custom-field.component'
import { FormsModule } from '@angular/forms';
import { CustomFieldEditComponent } from './custom-field-edit/custom-field-edit.component';
import { CoreModule } from '../core/core.module';
import { CustomFieldAssignComponent } from './custom-field-assign/custom-field-assign.component';
import { CustomFieldDeleteComponent } from './custom-field-delete/custom-field-delete.component';



@NgModule({
  declarations: [
    CustomFieldComponent,
    CustomFieldEditComponent,
    CustomFieldAssignComponent,
    CustomFieldDeleteComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CoreModule
  ],

  exports: [CustomFieldAssignComponent],

  entryComponents: [CustomFieldEditComponent]
})
export class BasicsModule { }
